import { getAccessToken, isTokenInvalidationError, handleTokenInvalidation } from './utils';

export interface UserProfile {
    id: number;
    user: number;
    email: string;
    username: string;
    first_name: string;
    last_name: string;
    avatar: string | null;
    bio: string | null;
    date_of_birth: string | null;
    phone_number: string | null;
    address: string | null;
    city: string | null;
    state: string | null;
    country: string | null;
    postal_code: string | null;
    is_verified: boolean;
    is_active: boolean;
    date_joined: string | null;
    created_at: string | null;
    updated_at: string | null;
}

export interface ShopProfile {
    id: number;
    name: string;
    address: string;
    phone: string;
    email: string;
    website?: string;
    logo?: string;
    tax_id?: string;
    owner?: number;
    cgst_rate?: number;
    sgst_rate?: number;
    care_instructions_description?: string;
    return_policy?: string;
    warranty_policy?: string;
}

class ProfileApiService {
    private baseUrl: string;

    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    // Static data helper for static site generation
    private getStaticProfile(): UserProfile {
        return {
            id: 1,
            user: 1,
            email: 'admin@example.com',
            username: 'admin',
            first_name: 'Admin',
            last_name: 'User',
            avatar: 'https://placehold.co/200x200?text=Admin+User',
            bio: 'SaarthiQ administrator',
            date_of_birth: '1990-01-01',
            phone_number: '+91 9876543210',
            address: '123 Main Street, Mumbai',
            city: 'Mumbai',
            state: 'Maharashtra',
            country: 'India',
            postal_code: '400001',
            is_verified: true,
            is_active: true,
            date_joined: new Date().toISOString(),
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString()
        };
    }

    // Static shop profile for static site generation
    private getStaticShopProfile(): ShopProfile {
        return {
            id: 1,
            name: 'Sample Jewelry Store',
            address: '123 Main Street, Mumbai, Maharashtra 400001',
            phone: '+91 9876543210',
            email: 'contact@samplejewelry.com',
            website: 'www.samplejewelry.com',
            logo: 'https://placehold.co/200x200?text=Store+Logo',
            tax_id: 'GST123456789',
            owner: 1,
            cgst_rate: 1.5,
            sgst_rate: 1.5,
            care_instructions_description: 'Clean with soft cloth. Avoid chemicals.',
            return_policy: '7 days return policy with receipt',
            warranty_policy: '1 year warranty against manufacturing defects'
        };
    }

    async getUserProfile(): Promise<UserProfile> {
        console.log('Getting static user profile');
        return this.getStaticProfile();
    }

    async updateUserProfile(data: Partial<UserProfile>): Promise<UserProfile> {
        console.log('Updating user profile (static):', data);
        // Return static profile with updated fields
        return {
            ...this.getStaticProfile(),
            ...data,
            updated_at: new Date().toISOString()
        };
    }

    async getShopProfile(): Promise<ShopProfile> {
        console.log('Getting static shop profile');
        return this.getStaticShopProfile();
    }

    async updateShopProfile(data: Partial<ShopProfile>): Promise<ShopProfile> {
        console.log('Updating shop profile (static):', data);
        // Return static profile with updated fields
        return {
            ...this.getStaticShopProfile(),
            ...data
        };
    }
}

// Create and export the service with the base URL
export const profileApiService = new ProfileApiService(process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8000');

// Export as profileService to match imports in other files
export const profileService = profileApiService;